import RouteEnum from "constants/RouteEnum";
import React from "react";
import LanguageControl from "../components/language-control/LanguageControl";
import NavItemComponent from "../components/nav-item-component/NavItemComponent";
import NavTopMenu from "../components/nav-top-menu/NavTopMenu";
import HeaderControl from "./components/header-control/HeaderControl";
import TopMenuContent from "./components/top-menu-content/TopMenuContent";

const Header: React.FC = () => {
  return (
    <header className="fixed-header">
      <div className="header-menu">
        <div className="navbar" style={{ minHeight: "60px" }}>
          <NavItemComponent redirectToPath={RouteEnum.Profile} />

          <NavTopMenu>
            <TopMenuContent />
          </NavTopMenu>

          <HeaderControl />

          <LanguageControl />
        </div>
      </div>
    </header>
  );
};

export default Header;
